import axios from 'axios';
import { MasterDataURL } from '../../../../config/UrlEndPoint';

export const URL = `${MasterDataURL}bank_account`;

// Get BankAccount All For use Combobox data
export function getBankAccountAll() {
    return axios.get(URL);
}

// Get BankAccount All For use Combobox data
export function getBankAccountAllCompany() {
    return axios.get(`${URL}/allcompany`);
}

// //Get By ID
export function getBankAccountById(bankAccountId) {
    return axios.get(`${URL}/${bankAccountId}`);
}

// items => filtered/sorted result for table data
export function findBankAccount(queryParams) {
    return axios.post(`${URL}/find`, queryParams);
}

// POST => POST: Create the bankAccount on the server
export function createBankAccount(bankAccount) {
    return axios.post(URL, bankAccount);
}

// UPDATE => PUT: update the bankAccount on the server
export function updateBankAccount(bankAccount) {
    return axios.put(`${URL}/${bankAccount.uuid}`, bankAccount);
}

